"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactIntl = require("react-intl");

var bedTypeLabels = (0, _reactIntl.defineMessages)({
    1: {
        "id": "formOptions.bedTypeLabels.1",
        "defaultMessage": "Twin"
    },
    2: {
        "id": "formOptions.bedTypeLabels.2",
        "defaultMessage": "Bed for Two"
    }
});

exports.default = bedTypeLabels;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/metadata/forms/formOptions/bed_type/bedTypeLabels.js
// module id = 1366
// module chunks = 0